module.exports = __webpack_public_path__ + "img/fortune-qr.7f97c9a9.png";